import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 7, viewBox: "0 0 8 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.10292 0.25L0.205811 7H8.00004L4.10292 0.25Z", fill: "#3E6378" }));
export default SvgArrowUp;
